module.exports = __webpack_public_path__ + "static/media/dk2061y.9a0916da.png";